import { DateTime } from 'luxon';
import React, { useMemo, useState } from 'react';
import { useGetAllEvents, UseGetAllEventsParams, useGetEventsAttendance } from '../../../services/react-query/events';
import { UserSettingsCollapseKeys } from '../../../types/User';
import { Loading } from '../../../uikit';
import AccordionSection from '../../AccordionSection';
import { ViewMode } from '../filters/EventsFilter';
import EventsTimelineHeader from './EventsTimelineHeader';
import EventsTimelineTable from './EventTimelineTable';
import _ from 'lodash';

interface IEventsTimelineProps {
  entityUuid: string;
  entityType: 'employees' | 'contacts' | 'account';
}

const EventsTimeline = ({ entityUuid, entityType }: IEventsTimelineProps) => {
  const [viewMode, setViewMode] = useState<ViewMode>(ViewMode.UPCOMING);

  const currentDate = useMemo(() => DateTime.now().startOf('day'), []);
  const queryParams: UseGetAllEventsParams = {
    per_page: 0,
    sort: {
      start_at: viewMode === ViewMode.UPCOMING ? 1 : -1,
    },
  };

  const filters = { [entityType]: entityUuid };
  if (viewMode === ViewMode.UPCOMING) {
    queryParams.filters = {
      ...filters,
      date_range: [currentDate.toISO(), null],
    };
  } else if (viewMode === ViewMode.PAST) {
    queryParams.filters = {
      ...filters,
      date_range: [null, currentDate.toISO()],
    };
  } else if (viewMode === ViewMode.ARCHIVED) {
    queryParams.filters = {
      ...filters,
      archived: ['true'],
    };
  } else {
    queryParams.filters = filters;
  }

  const { data: eventsData, isLoading: isGetAllEventsLoading } = useGetAllEvents({
    params: queryParams,
  });
  const { data: attendance } = useGetEventsAttendance({
    uuids: _.map(eventsData?.data, 'uuid'),
    employeeUuid: entityUuid,
    enabled: entityType === 'employees',
  });

  const events = eventsData?.data || [];

  return isGetAllEventsLoading ? (
    <Loading />
  ) : (
    <AccordionSection
      title="Events"
      collapseId={UserSettingsCollapseKeys.EMPLOYEE_ITEM_EVENTS_TIMELINE}
      headerElements={<EventsTimelineHeader entityType={entityType} viewMode={viewMode} onViewModeChange={setViewMode} />}
      hasData={events.length > 0}
      scrollable
    >
      <EventsTimelineTable timelineData={events} attendance={attendance} />
    </AccordionSection>
  );
};

export default EventsTimeline;
